// User enums, matching the backend values in app/models.py

export const ID_DOCUMENT_TYPE = {
  CITIZEN_CARD: "Citizen Card",
  PASSPORT: "Passport",
  RESIDENCE_CARD: "Residence Card",
};
